import React, { Suspense, lazy, useEffect, useState } from "react";
import { Routes, Route, useLocation, Link, Navigate, useNavigate } from "react-router-dom";
import { Button, Layout, Menu, theme } from "antd";
import PrivateRoutes from "./routes/private/PrivateRoutes";
import Login from "./pages/login/Login";

const { Content } = Layout;
export const AppRoutes = () => {
  const location = useLocation();
  const isLoggedIn = true;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return (
    <Routes>
      {isLoggedIn ? (
        <Route path="/*" element={<PrivateRoutes />} />
      ) : (
        <>
          <Route path="/" element={<Login />} />
          <Route path="*" element={<Navigate to="/login" />} />
        </>
      )}
    </Routes>
  );
}

